export const RoutesMap = {
  root: "/",
  signOut: "/sign-out",
  zuoraCallbackPage: `/zuora/callback`,
  notFound: "/not-found",
  fallback: "*",
};
